import { render, staticRenderFns } from "./NameFields.vue?vue&type=template&id=90faa42e"
import script from "./NameFields.vue?vue&type=script&lang=js"
export * from "./NameFields.vue?vue&type=script&lang=js"
import style0 from "./NameFields.vue?vue&type=style&index=0&id=90faa42e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports